// extracted by mini-css-extract-plugin
export var checkbox = "_47-0";
export var circle = "_47-3";
export var horizontalContainer = "_47-7";
export var sm = "_47-5";
export var switch0 = "_47-2";
export var switchDisabled = "_47-8";
export var switchEnabled = "_47-1";
export var textSwitchContainer = "_47-9";
export var textSwitchOption = "_47-a";
export var textSwitchOptionSelected = "_47-b";
export var verticalContainer = "_47-6";
export var xs = "_47-4";